import type { ReactNode } from "react";

/**
 * Book filter and sort for a bet table (Moss, 30 Oct 2026: place a whole
 * slate at one book). Plain selects: they work on a phone and need no state
 * beyond the page's own.
 */
export function TableToolbar<Sort extends string>({
  book,
  books,
  onBook,
  sort,
  sorts,
  onSort,
  children,
}: {
  book: string;
  /** Each book with the number of rows it would leave. */
  books: readonly { readonly name: string; readonly count: number }[];
  onBook: (book: string) => void;
  sort: Sort;
  sorts: readonly { readonly id: Sort; readonly label: string }[];
  onSort: (sort: Sort) => void;
  /** Extra controls ahead of the selects, such as a search box. */
  children?: ReactNode;
}) {
  return (
    <div className="table-toolbar">
      {children}
      <label>
        <span>Book</span>
        <select value={book} onChange={(event) => onBook(event.target.value)}>
          <option value="ALL">All books</option>
          {books.map((option) => (
            <option key={option.name} value={option.name}>
              {option.name} ({option.count})
            </option>
          ))}
        </select>
      </label>
      <label>
        <span>Sort</span>
        <select
          value={sort}
          onChange={(event) => onSort(event.target.value as Sort)}
        >
          {sorts.map((option) => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
